import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1280.000000 1280.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">

<path d="M3822 8538 l3 -2473 2385 -3 c1312 -1 2394 0 2405 2 20 5 20 13 20
2476 l0 2470 -2408 0 -2407 0 2 -2472z m1572 1711 c23 -11 55 -39 71 -62 l30
-42 2 -1030 c2 -1064 5 -1139 44 -1237 78 -199 239 -320 497 -374 162 -34 458
0 568 65 20 12 43 19 53 15 15 -6 45 -37 306 -319 230 -249 265 -288 265 -296
0 -4 -21 -21 -47 -38 -27 -17 -52 -34 -58 -38 -5 -5 -43 -25 -82 -46 -262
-137 -622 -204 -950 -178 -280 22 -448 64 -651 162 -109 53 -205 108 -210 121
-2 4 -10 8 -17 8 -7 0 -15 3 -17 8 -1 4 -16 17 -32 30 -96 74 -225 215 -292
319 -44 68 -137 260 -154 318 -32 110 -38 139 -65 340 -13 93 -15 271 -14
1128 0 691 4 1029 11 1050 13 38 42 73 83 98 27 17 55 19 324 19 277 0 296 -1
335 -21z m2313 6 c21 -9 45 -24 54 -33 46 -50 44 11 42 -1342 -2 -702 -7
-1276 -11 -1278 -5 -1 -26 17 -47 40 -35 40 -170 185 -340 367 -38 41 -99 107
-135 145 -56 61 -206 219 -292 309 l-28 29 0 819 c0 785 1 821 19 857 21 41
42 62 86 85 44 24 597 25 652 2z"/>
<path d="M9180 5273 c-306 -47 -496 -123 -677 -270 -82 -67 -102 -88 -118
-128 -17 -38 -13 -56 22 -102 40 -55 114 -55 174 1 122 113 287 198 479 246
75 19 104 21 255 17 179 -5 237 -16 386 -79 61 -25 179 -92 206 -117 68 -61
143 -111 166 -111 54 0 117 61 117 113 0 76 -186 226 -397 321 -193 87 -455
134 -613 109z"/>
<path d="M9104 4781 c-134 -33 -246 -88 -339 -168 -49 -42 -64 -68 -65 -110 0
-73 51 -119 123 -110 23 3 46 12 52 19 24 32 111 89 183 120 75 32 80 33 222
32 128 0 152 -3 205 -23 33 -13 72 -32 87 -42 14 -11 30 -19 34 -19 4 0 30
-19 58 -42 44 -38 56 -43 99 -43 42 0 52 4 73 30 31 39 40 86 22 121 -35 75
-235 194 -387 233 -107 26 -264 27 -367 2z"/>
<path d="M1170 3832 c0 -727 5 -830 51 -963 19 -58 56 -136 69 -149 3 -3 18
-25 34 -49 67 -103 186 -192 331 -247 132 -49 197 -59 395 -59 170 0 193 2
282 27 250 70 415 206 516 426 29 65 38 97 57 217 12 72 15 226 15 783 l0 692
-260 0 -260 0 0 -647 c0 -357 -5 -681 -10 -722 -18 -136 -84 -237 -188 -288
-51 -25 -67 -28 -162 -28 -86 0 -113 4 -151 21 -107 50 -169 141 -188 277 -7
50 -11 316 -11 733 l0 654 -260 0 -260 0 0 -678z"/>
<path d="M3651 4418 c-18 -51 -57 -163 -86 -248 -29 -85 -85 -245 -123 -355
-97 -278 -111 -318 -206 -595 -46 -135 -116 -337 -156 -450 -39 -113 -78 -225
-85 -250 -7 -25 -18 -58 -24 -73 -6 -16 -11 -33 -11 -38 0 -5 102 -9 253 -9
l252 0 54 165 c30 90 60 178 67 195 l13 30 369 0 369 0 38 -107 c20 -60 51
-147 67 -195 l31 -88 263 0 263 0 -55 158 c-31 86 -77 222 -104 302 -55 162
-88 258 -220 640 -51 146 -112 324 -135 395 -24 72 -67 195 -96 275 -28 80
-57 165 -65 190 -7 25 -21 68 -31 95 l-19 50 -295 3 -294 2 -34 -92z m445
-863 c61 -183 109 -336 106 -339 -10 -11 -451 -6 -457 4 -5 9 195 621 217 663
5 10 12 16 16 13 3 -4 56 -157 118 -341z"/>
<path d="M5096 4502 c-3 -5 -5 -479 -5 -1055 l0 -1047 245 0 245 0 -1 591 c-1
325 1 594 4 597 3 3 39 -64 80 -149 40 -85 102 -212 136 -284 35 -71 77 -161
95 -200 17 -38 49 -107 70 -152 l38 -83 117 0 116 0 61 128 c34 70 83 174 111
232 27 58 91 189 141 292 50 103 91 192 91 198 0 15 20 12 20 -2 0 -7 0 -273
0 -590 l-1 -578 251 0 250 0 0 1055 0 1055 -280 0 -280 0 -9 -22 c-5 -13 -52
-112 -105 -222 -53 -109 -96 -200 -96 -201 0 -2 -25 -56 -56 -121 -89 -189
-148 -315 -174 -371 -13 -29 -30 -53 -37 -53 -7 0 -13 4 -13 9 0 6 -22 57 -49
115 -28 57 -60 126 -72 153 -88 195 -239 526 -280 611 l-48 102 -280 0 c-154
0 -282 -4 -285 -8z"/>
<path d="M10184 4331 c-2 -2 -4 -438 -4 -968 l0 -963 190 0 190 0 0 75 c0 41
3 75 6 75 3 0 29 -21 57 -46 67 -60 127 -90 235 -115 198 -48 399 8 542 151
154 153 221 354 207 615 -13 221 -87 391 -228 518 -103 94 -202 135 -345 144
-106 7 -204 -8 -281 -43 -55 -26 -140 -86 -161 -116 -7 -10 -17 -18 -23 -18
-5 0 -9 135 -9 345 l0 345 -37 0 c-21 1 -105 2 -186 3 -82 1 -151 0 -153 -2z
m836 -865 c73 -38 118 -85 157 -163 33 -67 38 -85 41 -168 7 -150 -23 -245
-103 -328 -65 -69 -114 -90 -217 -95 -76 -4 -92 -1 -141 21 -141 65 -219 226
-202 419 13 143 88 257 205 313 49 23 65 26 140 22 56 -2 97 -9 120 -21z"/>
<path d="M9215 4309 c-72 -21 -126 -100 -127 -183 -1 -131 118 -229 237 -196
71 20 117 59 138 116 20 56 21 84 7 136 -29 103 -144 160 -255 127z"/>
<path d="M7775 3800 c-167 -44 -260 -110 -327 -231 -39 -71 -52 -146 -40 -232
28 -211 164 -312 527 -392 105 -23 181 -52 205 -78 14 -14 20 -35 20 -68 0
-39 -5 -52 -31 -77 -65 -64 -218 -69 -343 -12 -46 21 -136 104 -136 126 0 8
-8 14 -17 14 -22 0 -273 -149 -273 -163 0 -23 65 -110 116 -155 108 -96 258
-149 456 -159 99 -5 131 -3 212 16 128 30 222 78 283 145 90 98 119 195 102
340 -13 119 -58 189 -163 254 -95 59 -139 75 -379 136 -154 40 -162 43 -196
80 -20 21 -23 32 -18 73 9 79 83 121 197 110 103 -9 140 -26 206 -93 l61 -63
39 27 c21 14 45 31 51 38 7 7 47 34 88 60 41 26 75 53 75 59 0 13 -50 79 -78
105 -75 68 -168 114 -288 145 -86 21 -259 19 -349 -5z"/>
<path d="M8680 3328 c0 -273 4 -490 11 -528 32 -200 150 -346 324 -402 101
-32 265 -32 350 1 67 27 136 70 178 113 15 15 29 28 32 28 3 0 5 -31 5 -70 l0
-70 190 0 190 0 0 695 0 695 -190 0 -190 0 0 -408 c0 -446 -4 -485 -58 -566
-53 -78 -131 -111 -244 -103 -57 4 -74 9 -112 38 -43 33 -57 52 -79 114 -8 19
-13 188 -17 475 l-5 445 -192 3 -193 2 0 -462z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
